module.exports = __webpack_public_path__ + "static/media/306361.04e94b2d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/306361.pdf
// module id = 879
// module chunks = 0